<template>
  <div v-loading="loading" class="success">
    <img src="@/assets/Success.png" alt />
    <span>{{ $t("hzmbG.success.title") }}</span>
    <p class="ps_spNo">
      {{ $t("hzmbG.success.applicationNo") }}{{ applicationNo }}
    </p>
    <span id="preview_message">{{ message }}</span>
    <GradientBtn style="margin-top: 24px" @click="back">{{
      $t("message.back")
    }}</GradientBtn>
  </div>
</template>

<script>
import MessageAPI from "@/api/hzmb-gh/MessageAPI";
import LoginAPI from "@/api/LoginAPI";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
import GradientBtn from "@/components/GradientBtn";
import { wordBreak } from "@/filters";
export default {
  components: { GradientBtn },
  data() {
    return {
      serviceType: "HZMB_G_FIRST",
      applicationNo: this.$route.query.applicationNo,
      applicationId: this.$route.query.id,
      loading: false,
      message: "",
    };
  },
  methods: {
    // 獲取通知訊息
    async getMessage() {
      try {
        this.loading = true;
        const serviceType = this.serviceType;
        const res = await MessageAPI.message(
          this.applicationId,
          serviceType,
          "SUBMITTED"
        );
        this.message = res[this.$t("message.lang")];
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    async logout() {
      try {
        this.loading = true;
        await LoginAPI.logout();
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    getServiceTypeDetail() {
      this.loading = true;
      const serviceType = this.serviceType;
      ServiceTypeConfigAPI.getDetails(serviceType)
        .then((res) => {
          this.loading = false;
          res.nameTc = wordBreak(res.nameTc);
          res.nameSc = wordBreak(res.nameSc);
          res.namePt = wordBreak(res.namePt);
          res.nameEn = wordBreak(res.nameEn);
          this.$store.commit("changeServiceTypeConfig", res);
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    back() {
      this.$router.push("/hzmb-truck-hk");
    },
  },
  created() {
    this.getServiceTypeDetail();
    this.getMessage();
  },
};
</script>

<style lang="scss" scoped>
.ps_spNo {
  font-size: 26px;
}
</style>
